// extracted by mini-css-extract-plugin
export default {"page":"aY-z","cartModal":"bY-z","checkout":"cY-z","placeholder":"dY-z","account":"eY-z"};